import axiosInstance from '../../lib/api/axios';
import { PageParameters } from '../../lib/api/types';
import { getServerUrl } from '../../lib/utils';
import { SortOrders } from '../../stores/types';
import { GetEntriesResponse } from '../entries/types';
import { Table } from './types';

export const getTable = async (databaseSlug: string, tableSlug: string): Promise<Table> => {
  const { data } = await axiosInstance.get(
    `${getServerUrl()}/databases/${databaseSlug}/tables/${tableSlug}`,
  );
  return data;
};

export const getTableEntries = async (
  databaseSlug: string,
  tableSlug: string,
  pageParameters: PageParameters,
  query?: string,
  sorting?: [string, SortOrders],
  filters?: Record<string, string>,
): Promise<GetEntriesResponse> => {
  const { page, perPage } = pageParameters;
  const [sortBy, sortOrder] = sorting || [];
  const { data } = await axiosInstance.get(
    `${getServerUrl()}/${databaseSlug}/${tableSlug}`,
    {
      params: {
        page,
        perPage,
        query,
        sortBy,
        sortOrder,
        ...filters,
        invalidEntries: true,
        derefrenceLevel: 1,
      },
    },
  );
  return data;
};
